var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.56838 15.0918H5.32229V8.38281H7.46096L7.81252 5.7168H5.32229V3.87109C5.32229 3.46094 5.38088 3.13867 5.55666 2.93359C5.73244 2.69922 6.1133 2.58203 6.64065 2.58203H8.0469V0.208984C7.51955 0.150391 6.81643 0.0917969 5.99612 0.0917969C4.94143 0.0917969 4.12112 0.414062 3.50588 1.0293C2.86135 1.64453 2.56838 2.49414 2.56838 3.60742V5.7168H0.312522V8.38281H2.56838V15.0918Z"}));
}

Facebook.defaultProps = {"width":"9","height":"16","viewBox":"0 0 9 16","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
